document.addEventListener("DOMContentLoaded", function () {
	let prevScrollPos = window.scrollY;
	let scrollCutoffPos = window.scrollY;

	const mobileHeader = document.querySelector(
		".mobile-header.wp-block-template-part",
	);

	if (!mobileHeader) {
		return;
	}

	window.addEventListener("scroll", function () {
		const currentScrollPos = window.scrollY;

		if (mobileHeader.matches(":hover")) {
			scrollCutoffPos = currentScrollPos;
			mobileHeader.classList.remove("hide");

			return;
		}

		const isScrollDown = prevScrollPos < currentScrollPos;

		if (scrollCutoffPos - 50 > currentScrollPos || currentScrollPos < 50) {
			// user has scrolled up

			mobileHeader.classList.remove("hide");

			scrollCutoffPos = currentScrollPos;
		} else if (scrollCutoffPos + 20 < currentScrollPos && isScrollDown) {
			// user has scrolled down

			mobileHeader.classList.add("hide");

			scrollCutoffPos = currentScrollPos;
		}

		prevScrollPos = currentScrollPos;
	});

	/* Mobile menu */
	const mobileMenuToggle = document.querySelector(".wp-block-navigation__mobile-menu-toggle");
	const mobileMenuContent = document.querySelector(".wp-block-navigation__mobile-menu-content");

	if (!mobileMenuToggle || !mobileMenuContent || !mobileHeader) {
			return;
	}

	// Create and add a close button dynamically
	const closeButton = mobileMenuContent.querySelector(".wp-block-button.icon-close");

	// Toggle menu on hamburger button click
	mobileMenuToggle.addEventListener("click", (e) => {
			e.preventDefault();

			mobileHeader.classList.toggle("menu-open");
			document.body.classList.toggle("menu-open");
			mobileMenuContent.classList.toggle("visible");
	});

	// Close menu when clicking the close button
	closeButton.addEventListener("click", () => {
			mobileHeader.classList.remove("menu-open");
			document.body.classList.remove("menu-open");
			mobileMenuContent.classList.remove("visible");
	});

	// Close menu on Esc key press
	document.addEventListener("keydown", (e) => {
			if (e.key === "Escape" && mobileHeader.classList.contains("menu-open")) {
					mobileHeader.classList.remove("menu-open");
					document.body.classList.remove("menu-open");
					mobileMenuContent.classList.remove("visible");
			}
	});

});
